<template>
    <div>
        <div class="toptitle">服务企业</div>
        <div class="topcont">

            <div v-if="qiyeList.length" class="fuwubox">
                <!-- <vue-seamless-scroll :data="qiyeList" :class-option="defaultOptiontwo" class="warp"> -->
                <div v-for="item in qiyeList" :key="item.id" class="flex fone">
                    <img :src="item.avatar" class="fimg" alt="">
                    <div>{{ item.title || '' }}</div>
                </div>
                <!-- </vue-seamless-scroll> -->
            </div>

            <empty v-else></empty>
            <div style="margin-top: 8px;justify-content: flex-end;" class="flex">
                <el-pagination layout="prev, pager, next" @current-change="pageChnange" :total="total"
                    :current-page="page" :page-size="7" background>
                </el-pagination>
            </div>
        </div>

    </div>
</template>
<script>
import vueSeamlessScroll from "vue-seamless-scroll";

import empty from '@/components/empty/empty.vue';
export default {
    components: {
        empty, vueSeamlessScroll
    },
    data() {
        return {
            page: 1,
            total: 0,
            qiyeList: []
        }
    },
    mounted() {
        this.getQiyeList()
    },
    computed: {
        defaultOptiontwo() {
            return {
                step: 0.2, // 数值越大速度滚动越快
                limitMoveNum: this.qiyeList.length, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: true, // 是否开启鼠标悬停stop
                direction: 1, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            }
        }
    },
    methods: {
        pageChnange(e) {
            this.page = e
            this.getQiyeList()
        },
        getQiyeList() {
            let data = {
                page: this.page,
                pagesize: 7
            }
            this.$api({
                url: '/api/central_control/service_enterprise',
                method: 'POST',
                data
            }).then(res => {
                console.log(res, "res")
                this.qiyeList = res.data.data
                this.total = res.data.total
            })
        },

    }
}
</script>
<style lang="less" scoped>
// .warp {
//     height: 400px;
//     margin: 0 auto;
//     overflow: hidden;

//     ul {
//         list-style: none;
//         padding: 0;
//         margin: 0 auto;

//         li,
//         a {
//             display: block;
//             height: 30px;
//             line-height: 30px;
//             display: flex;
//             justify-content: space-between;
//             font-size: 15px;
//         }
//     }
// }

.topcont {
    background: url('@/assets/conbg.png') no-repeat 0 0/100% 100%;
    width: 100%;
    // height: 100%;
    height: calc(((100vh - 100px) / 2) - 50px);
    padding: 10px 26px 20px;
    color: #fff;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

}

.fone {
    height: 40px;
    font-size: 13px;
    color: #eee;

    .fimg {
        width: 27px;
        min-width: 27px;
        height: 27px;
        margin-right: 10px;
        border-radius: 5px;
    }

    &:nth-child(2n+2) {
        background: #082667;
    }
}

::v-deep {
    .number {
        background: transparent !important;
    }

    .active {
        background: #16367B !important;
    }

    .btn-prev {
        background: transparent !important;
    }

    .btn-next {
        background: transparent !important;
    }
}
</style>